export const SkeletonBar = () => (
  <div className="h-3 w-full animate-pulse rounded bg-neutral-subtle" />
);
